import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  ConfigProcessingEnum,
  EmailProviderEnum,
  IEmailConfig,
} from 'Modules/Communication/shared/models/EmailConfig'

const emailSettingsSlice = createSlice({
  name: 'emailConfiguration',
  initialState: {
    data: null as IEmailConfig | null,
    loading: true,
    error: null,
    processing: null as ConfigProcessingEnum | null,
    processingError: null as ConfigProcessingEnum | null,
  },
  reducers: {
    /**
     * Fetch
     */
    fetchRequest: (state) => {
      state.data = null
      state.loading = true
      state.error = null
    },
    fetchSuccess: (state, action: PayloadAction<IEmailConfig | null>) => {
      state.data = action.payload
      state.loading = false
      state.error = null
    },
    fetchError: (state, action) => {
      state.loading = false
      state.error = action.payload
    },

    /**
     * Init
     */
    initFetchRequest: (
      state,
      _: PayloadAction<{
        provider: EmailProviderEnum
        returnUrl: string
        email: string
      }>
    ) => {
      state.processing = ConfigProcessingEnum.init
      state.processingError = null
    },
    initFetchError: (state) => {
      state.processing = null
      state.processingError = ConfigProcessingEnum.init
    },

    /**
     * Confirm
     */
    confirmRequested: (
      state,
      _: PayloadAction<{
        provider: EmailProviderEnum
        email: string
        syncFromDate: Date
      }>
    ) => {
      state.processing = ConfigProcessingEnum.confirm
      state.processingError = null
    },
    confirmSuccess: (state) => {
      state.processing = null
      state.processingError = null
    },
    confirmError: (state) => {
      state.processing = null
      state.processingError = ConfigProcessingEnum.confirm
    },

    /**
     * Sync
     */
    syncRequested: (
      state,
      _: PayloadAction<{
        provider: EmailProviderEnum
        syncFromDate: Date
      }>
    ) => {
      state.processing = ConfigProcessingEnum.sync
      state.processingError = null
    },
    syncSuccess: (state) => {
      state.processing = null
      state.processingError = null
    },
    syncError: (state) => {
      state.processing = null
      state.processingError = ConfigProcessingEnum.sync
    },

    /**
     * Delete
     */
    deleteRequested: (state) => {
      state.processing = ConfigProcessingEnum.delete
      state.processingError = null
    },
    deleteSuccess: (state) => {
      state.data = null
      state.processing = null
      state.processingError = null
    },
    deleteError: (state) => {
      state.processing = null
      state.processingError = ConfigProcessingEnum.delete
    },

    /**
     * Gmail SMTP config
     */
    confirmSmtpRequested: (
      state,
      _: PayloadAction<{
        email: string
        password: string
        provider: EmailProviderEnum
        syncFromDate?: Date
      }>
    ) => {
      state.processing = ConfigProcessingEnum.init
      state.processingError = null
    },
    confirmSmtpSuccess: (state) => {
      state.processing = null
      state.processingError = null
    },
    confirmSmtpError: (state) => {
      state.processing = null
      state.processingError = ConfigProcessingEnum.confirm
    },
    syncSmtp: (
      state,
      _: PayloadAction<{
        syncFromDate: Date
        emailProvider: EmailProviderEnum
      }>
    ) => {
      state.processing = ConfigProcessingEnum.sync
      state.processingError = null
    },
  },
})

export default emailSettingsSlice
